import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaPhoneAlt, FaDownload, FaChevronUp } from 'react-icons/fa';
import '../css/floatingbuttons.css';

function FloatingButtons({ setShowModal }) {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };
    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, [showScroll]);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Left side: Download Product List */}
      <div className="floating-left d-none d-md-block">
        <a href="#download" className="floating-btn-download" onClick={(e) => { e.preventDefault(); setShowModal(true); }}>
          <FaDownload className="floating-icon" />
          <span className="floating-text">Download Product List</span>
        </a>
      </div>

      {/* Right side: Circular WhatsApp & Call */}
      <div className="floating-right">
        <a href="tel:+917827552889" className="floating-btn-call-circle mb-3">
          <FaPhoneAlt className="floating-icon-circle" />
        </a>
        <a 
          href="https://wa.me/917827552889?text=Hello%2C%20I%20am%20interested%20in%20your%20PCD%20Pharma%20Franchise%20opportunity." 
          target="_blank" 
          rel="noopener noreferrer" 
          className="floating-btn-whatsapp-circle"
        >
          <FaWhatsapp className="floating-icon-circle" />
        </a>
        
        {/* Scroll To Top */}
        <div className={`floating-scroll-top mt-3 ${showScroll ? 'visible' : 'hidden'}`} onClick={scrollTop}>
          <FaChevronUp className="floating-icon-circle" style={{ fontSize: '20px' }} />
        </div>
      </div>

      {/* Mobile Sticky Bottom Bar */}
      <div className="floating-mobile-bottom d-block d-md-none">
        <button onClick={(e) => { e.preventDefault(); setShowModal(true); }} className="btn-place-query">
          PLACE A QUERY
        </button>
      </div>
    </>
  );
}

export default FloatingButtons;
